import { confetti } from 'tsparticles-confetti';

export default class Confetti {
    constructor() {
        this.baseConfig = {
            shapes: ['image'],
            shapeOptions: {
                image: [],
            },
        };

        this.default = {
            color: 'Blue',
            duration: 15,
            scalarMin: 0.4,
            scalarMax: 2,
            count: 1,
            imageCount: 25,
            launchDelay: 0,
        };
    }

    init() {
        this.initialized = true;
        this.duration = (window.confettiDuration ? window.confettiDuration : this.default.duration) * 1000;
        this.animationEnd = Date.now() + this.duration;

        if (window.confettiScalarMin) {
            this.default.scalarMin = window.confettiScalarMin;
        }

        if (window.confettiScalarMax) {
            this.default.scalarMax = window.confettiScalarMax;
        }

        if (window.confettiCount) {
            this.default.count = window.confettiCount;
        }

        if (window.confettiImageCount) {
            this.default.imageCount = window.confettiImageCount;
        }

        if (window.confettiColor) {
            this.default.color = window.confettiColor;
        }

        if (window.confettiLaunchDelay) {
            this.default.launchDelay = window.confettiLaunchDelay;
        }

        if (this.default.color === 'Gold') {
            this.baseConfig.shapeOptions.image = this.getGoldImages();
        } else {
            this.baseConfig.shapeOptions.image = this.getImages();
        }

        setTimeout(() => {
            this.frame();
        }, this.default.launchDelay * 1000);
    }

    frame() {
        const timeLeft = this.animationEnd - Date.now();
        const ticks = Math.max(200, 500 * (timeLeft / this.duration));

        let skew = 1;

        skew = Math.max(0.8, skew - 0.001);

        confetti({
            ...this.baseConfig,
            startVelocity: 0,
            ticks,
            origin: {
                x: Math.random(),
                // since particles fall down, skew start toward the top
                y: Math.random() * skew - 0.2,
            },
            gravity: this.randomInRange(0.4, 0.6),
            scalar: this.randomInRange(this.default.scalarMin, this.default.scalarMax),
            drift: this.randomInRange(-0.4, 0.4),
            count: this.default.count,
        });

        if (timeLeft > 0) {
            requestAnimationFrame(this.frame.bind(this));
        }
    }

    // eslint-disable-next-line class-methods-use-this
    randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    // eslint-disable-next-line class-methods-use-this
    getGoldImages() {
        const array = [];

        for (let i = 1; i <= this.default.imageCount; i += 1) {
            array.push(
                {
                    src: `${window.location.origin}/dist/images/confetti/XL/XL-Gold-Confetti-${100 + i}.png`,
                    width: 107,
                    height: 77,
                },
            );
        }

        return array;
    }

    // eslint-disable-next-line class-methods-use-this
    getImages() {
        const array = [];

        for (let i = 1; i <= this.default.imageCount; i += 1) {
            array.push(
                {
                    src: `${window.location.origin}/dist/images/confetti/blue/XL/XL-Blue-Confetti-${100 + i}.png`,
                    width: 107,
                    height: 77,
                },
            );
        }

        return array;
    }
}
